import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgSearchNews(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.486 85.084a9.542 9.542 0 0 1-9.544-9.544V22.25h55.676v53.29a9.542 9.542 0 0 0 9.544 9.544H31.486Z"
        fill="#F1F5F9"
      />
      <path
        d="M104.494 38.157a7.789 7.789 0 0 0-7.787 7.787V75.54c0 5.265-4.28 9.544-9.545 9.544s-9.544-4.279-9.544-9.544V38.157h26.876Z"
        fill="#E2E8F0"
      />
      <path
        d="M112.288 58.774H96.707v-12.83a7.797 7.797 0 0 1 7.794-7.794 7.797 7.797 0 0 1 7.795 7.794v12.83h-.008Z"
        fill="#F1F5F9"
      />
      <path
        d="M95.906 75.54V50.724a.8.8 0 0 1 1.601 0V75.54c0 5.715-4.63 10.345-10.345 10.345a.8.8 0 0 1 0-1.6 8.742 8.742 0 0 0 8.744-8.745Z"
        fill="#0F172A"
      />
      <path d="M45.302 30.013H30.738v19.558h14.564V30.013Z" fill="#CAE8DF" />
      <path
        d="M68.94 29.841a.8.8 0 0 1 0 1.6H51.195a.8.8 0 1 1 0-1.6H68.94ZM68.94 35.942a.8.8 0 0 1 0 1.6H51.195a.8.8 0 1 1 0-1.6H68.94ZM68.94 42.035a.8.8 0 0 1 0 1.6H51.195a.8.8 0 1 1 0-1.6H68.94ZM68.94 48.135a.8.8 0 0 1 0 1.6H51.195a.8.8 0 1 1 0-1.6H68.94ZM68.94 54.236a.8.8 0 0 1 0 1.6H30.74a.8.8 0 1 1 0-1.6H68.94ZM68.94 60.336a.8.8 0 0 1 0 1.6H30.74a.8.8 0 1 1 0-1.6H68.94ZM39.4 66.437a.8.8 0 1 1 0 1.6h-8.662a.8.8 0 1 1 0-1.6H39.4ZM39.4 72.537a.8.8 0 1 1 0 1.6h-8.662a.8.8 0 1 1 0-1.6H39.4Z"
        fill="#B3C0D0"
      />
      <path d="M69.585 66.624H45.302v7.317h24.283v-7.317Z" fill="#CAE8DF" />
      <path
        d="m39.774 75.738 21.5 17.927a4.743 4.743 0 1 1-6.354 7.03l-20-19.587 4.854-5.37Z"
        fill="#007A5F"
      />
      <path d="m46.532 81.372.637 11.733L34.92 81.108l4.854-5.37 6.758 5.634Z" fill="#00664F" />
      <path
        d="m46.532 81.372.637 11.732L34.92 81.108l4.854-5.37 6.758 5.634Zm-9.395-.332 8.211 8.042-.377-6.928-5.04-4.203-2.794 3.089Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 86.872c9.704 4.97 21.6 1.13 26.568-8.576 4.969-9.704 1.13-21.6-8.576-26.568-9.705-4.97-21.6-1.13-26.569 8.575-4.968 9.705-1.129 21.6 8.576 26.57Z"
        fill="#78B441"
      />
      <path
        d="M42.219 69.625c0 7.814-6.335 14.148-14.149 14.148-7.813 0-14.148-6.334-14.148-14.148s6.335-14.148 14.148-14.148c7.814 0 14.149 6.334 14.149 14.148Z"
        fill="#E6F4F0"
      />
      <path
        d="M16.413 69.624c0-6.438 5.219-11.657 11.657-11.657a.8.8 0 1 1 0 1.6c-5.554 0-10.057 4.503-10.058 10.057a.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
    </svg>
  )
}
export default wrapIllustration(SvgSearchNews)
